export default function Fader(props)
{
    const animationStage = props.animationStage

    return (
        <div
            className={animationStage >= 5 ? 'home-fader out' : 'home-fader'}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.539)',
                pointerEvents: 'none',
                opacity: animationStage >= 5 ? 0 : 1,
                transition: 'opacity 2s'
            }}

        />
    )
}